import axios from 'axios'

async function  send_response(dispatch,send_data,assessment,token,setOpen,setMessage,setResponse,setTime,setHasStarted,setAss,setRecentQuestion,setRecentSection,setSubmitting,setQuestion,setQuestionType,setIsPaused,setDiv,setSe_time,setNewSection,setHasFinished,isAuth){

    setSubmitting(true)
    setIsPaused(true)

    const URL =`${process.env.REACT_APP_SERVER_AUTH_URL}send-assessment/`

      const sendResp = await axios.post(URL,send_data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

    if (sendResp?.status == 200 && sendResp?.data.success) {

      setResponse("")
      setQuestion(sendResp?.data?.question?.question)
      setAss({
          ...sendResp?.data?.question,
          ...sendResp?.data?.section
      })
      setQuestionType(sendResp?.data?.question?.question_type)
      setIsPaused(false)
      setDiv((sendResp?.data?.section?.duration*60)/sendResp?.data?.section?.total_questions) 

      if (sendResp?.data?.newSection && !sendResp?.data?.hadEnded) {
        setSe_time(sendResp?.data?.section?.duration*60)
        setDiv((sendResp?.data?.section?.duration*60)/sendResp?.data?.section?.total_questions) 
        setNewSection(true)
        setRecentSection(sendResp?.data?.sectionIndex)
        setRecentQuestion(0)
        setAss({
            ...sendResp?.data?.question,
            ...sendResp?.data?.section
        })
        setIsPaused(true)
      } else {  
        setNewSection(false)
        setRecentQuestion(prev=>prev+1)  
        // setHasStarted(false)
        // setHasFinished(true)
      }
    }else if(sendResp?.status == 200 && sendResp?.data?.hasEnded){
        setIsPaused(true)
        setTime(0)
        setDiv(0)
        setHasStarted(false)
        setHasFinished(true)
    } else{
      setIsPaused(true)
      setMessage(sendResp?.data?.message)
      setOpen(true)
    }
    setSubmitting(false)
}

export default send_response